import { render, staticRenderFns } from "./DriversLookup.vue?vue&type=template&id=2b896833&scoped=true"
import script from "./DriversLookup.vue?vue&type=script&lang=ts"
export * from "./DriversLookup.vue?vue&type=script&lang=ts"
import style0 from "./DriversLookup.vue?vue&type=style&index=0&id=2b896833&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b896833",
  null
  
)

export default component.exports